import { createContext } from 'react';

const TabsFocusContext = createContext(false);

export default TabsFocusContext;
